import React from 'react';

import UserIcon from 'components/user_icon';

interface Props {
  assignee?: { name: string };
}

export default function Assignee({ assignee }: Props) {
  const user = assignee || { imageUrl: '/images/default-profile-photo.png', name: 'Unassigned' };

  return (
    <UserIcon size="sm" user={user} />
  );
}
